/**
 * useViewportFlags tracks responsive breakpoints (mobile/desktop) so AppContent
 * can adjust layouts just like the original window resize handlers.
 */
import { useEffect, useState } from "react";
import { breakpoints } from "@/design-system/foundations/theme";

const MOBILE_WIDTH = Number.parseInt(breakpoints.md, 10);
const DESKTOP_WIDTH = Number.parseInt(breakpoints.lg, 10);

export const useViewportFlags = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_WIDTH);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= DESKTOP_WIDTH);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_WIDTH);
      setIsDesktop(window.innerWidth >= DESKTOP_WIDTH);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile, isDesktop };
};
